import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import { API } from "@/lib/api";
import { DEFAULT_SETTINGS } from "@/lib/constants";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ScrubSection from "@/components/landing/ScrubSection";
import Services from "@/components/landing/Services";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Reviews from "@/components/landing/Reviews";
import Audiences from "@/components/landing/Audiences";
import Process from "@/components/landing/Process";
import QuoteSection from "@/components/landing/QuoteSection";
import Footer from "@/components/landing/Footer";
import MobileBar from "@/components/landing/MobileBar";

export default function Landing() {
  const [site, setSite] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/site`)
      .then((r) => setSite(r.data))
      .catch(() => setSite({ settings: {}, realizations: [], reviews: [] }));
  }, []);

  const settings = { ...DEFAULT_SETTINGS, ...(site?.settings || {}) };

  return (
    <div className="bg-cream text-ink font-sans antialiased" data-testid="landing-page">
      <Header settings={settings} />
      <main>
        <Hero settings={settings} />
        <ScrubSection settings={settings} />
        <Services settings={settings} services={site?.services || []} />
        <BeforeAfter realizations={site?.realizations || []} />
        <Reviews reviews={site?.reviews || []} />
        <Audiences settings={settings} />
        <Process />
        <QuoteSection settings={settings} />
      </main>
      <Footer settings={settings} />
      <MobileBar settings={settings} />
    </div>
  );
}
